import MicrotraderImg from "../../../assets/projectImages/microtrader.svg";
import StarshipImg from "../../../assets/projectImages/starship.svg";
import PatinaImg from "../../../assets/projectImages/patina.svg";
import RicochetRobots from "../../../assets/projectImages/ricochet.png";
import SarcasmDetection from "../../../assets/projectImages/neuralnet.png";
import GalaxyRaiderImg from "../../../assets/projectImages/GalaxyRaider.png";
import Logo from "../../../assets/logo.png";
import MedMapsImage from "../../../assets/projectImages/MedMaps.png";

export const PROJECTS = [
  {
    id: "starship",
    title: "Starship",
    description:
      "A Rust platform for coordinating large-scale MMO raids across Discord — the successor to an earlier bot of mine that grew to 70,000+ users across 70+ communities. Handles membership, event organization, and moderation; designed in Rust for memory safety and high-concurrency throughput.",
    link: "https://github.com/azolyomi/starship",
    image: StarshipImg,
    techTags: ["Rust", "Discord"],
    gradient: {
      background: "linear-gradient(to bottom right, #1a0f0a, #9a3412, #fb923c)",
      accent: "#fb923c",
      from: "#9a3412",
      to: "#fb923c",
    },
    learningTargets: [
      { target: "Rust", desc: "memory-safe, high-concurrency systems language" },
      { target: "Discord API", desc: "large-scale raid coordination" },
      { target: "Concurrency", desc: "high-throughput event handling" },
    ],
  },
  {
    id: "microtrader",
    title: "Microtrader",
    description:
      "A Rust engine for executing trades on the open market through Alpaca with sub-ms local latency. Supports paper-trading, backtesting, and realtime P&L visualization. Backed by a network of private algorithms — from time-series models to bar heuristics — that emit trade events via gRPC and asyncio Python services, persisted to PostgreSQL.",
    link: "https://github.com/azolyomi/microtrader",
    image: MicrotraderImg,
    techTags: ["Rust", "gRPC", "asyncio", "PostgreSQL", "Alpaca"],
    gradient: {
      background: "linear-gradient(to bottom right, #0a1628, #1a3a5c, #2d6a9f)",
      accent: "#2d6a9f",
      from: "#1a3a5c",
      to: "#2d6a9f",
    },
    learningTargets: [
      { target: "Rust", desc: "high-performance systems language" },
      { target: "gRPC", desc: "low-latency service communication" },
      { target: "PostgreSQL", desc: "trade and algorithm data persistence" },
      { target: "Alpaca API", desc: "brokerage integration for live trading" },
    ],
  },
  {
    id: "patina",
    title: "Patina Compiler",
    description:
      "A register-based compiler for the Patina language built from scratch in OCaml. Includes an AST module, tokenizer, regex-to-NFA converter, lexer, parser, type checker, code generator, and optimizations.",
    link: null,
    image: PatinaImg,
    techTags: ["OCaml", "Compilers", "Type Systems"],
    gradient: {
      background: "linear-gradient(to bottom right, #1a0a2e, #3d1f6d, #7b2ff7)",
      accent: "#7b2ff7",
      from: "#3d1f6d",
      to: "#7b2ff7",
    },
    learningTargets: [
      {
        target: "OCaml",
        desc: "functional programming for compiler construction",
      },
      { target: "Lexing/Parsing", desc: "regex-to-NFA, tokenizer, parser" },
      { target: "Type Checking", desc: "static type inference and validation" },
      {
        target: "Code Gen",
        desc: "register-based code generation and optimization",
      },
    ],
  },
  {
    id: "galaxyraider",
    title: "Galaxy Raider",
    description:
      "A high-performance Discord bot serving 70,000+ people, revitalizing over 70 communities in a childhood video game. Provides large-scale infrastructure for user membership, organization, and regulation.",
    link: "https://github.com/azolyomi/GalaxyRaider",
    image: GalaxyRaiderImg,
    techTags: ["Node.js", "Discord.js", "MongoDB", "MySQL"],
    gradient: {
      background: "linear-gradient(to bottom right, #131313, #42083B)",
      accent: "#851547",
      from: "#42083B",
      to: "#851547",
    },
    learningTargets: [
      { target: "Node.js", desc: "primary scripting language" },
      { target: "Eris", desc: "javascript discord library" },
      { target: "MongoDB", desc: "server configs, user data" },
      { target: "MySQL", desc: "backup database" },
    ],
  },
  {
    id: "ricochet",
    title: "Ricochet Robots",
    description:
      "Online port for the board game, built in 24h for a hackathon. Winner of 'Best New Hack' category.",
    link: "https://zolyo.me/ricochet",
    image: RicochetRobots,
    techTags: ["Node.js", "React"],
    gradient: {
      background: "linear-gradient(to bottom right, #4a0509, #7d2525)",
      accent: "#E10600",
      from: "#E10600",
      to: "#f5af19",
    },
    learningTargets: [
      { target: "Node.js", desc: "primary scripting language" },
      { target: "React", desc: "board state updates & rendering" },
    ],
  },
  {
    id: "zolyo.me",
    title: "zolyo.me",
    description:
      "A video-game themed portfolio website showcasing projects and experience.",
    link: "https://zolyo.me",
    image: Logo,
    techTags: ["Node.js", "React", "HTML", "CSS"],
    gradient: {
      background: "#101010",
      accent: "#5c5c5c",
      from: "magenta",
      to: "gold",
    },
    learningTargets: [
      { target: "Node.js", desc: "primary scripting language" },
      { target: "React", desc: "cutting-edge web framework" },
      { target: "JSX", desc: "React's unique integration of HTML" },
      { target: "CSS", desc: "modern styling for web browsers" },
    ],
  },
  {
    id: "medmaps",
    title: "MedMaps",
    description:
      "A medical pocket dictionary built with React Native, leveraged by 2,000+ medical students and faculty in daily patient visits at Duke University.",
    link: "https://apps.apple.com/us/app/id1519324957",
    image: MedMapsImage,
    techTags: ["Swift", "React Native", "XCode"],
    gradient: {
      background: "linear-gradient(to bottom right, #080808, #000D43)",
      accent: "#152898",
      from: "#890097",
      to: "#8719EF",
    },
    learningTargets: [
      { target: "XCode", desc: "Apple's iOS dev toolkit" },
      { target: "Swift", desc: "XCode's native language" },
      { target: "React Native", desc: "cross-platform mobile framework" },
      { target: "App Store", desc: "how to sign, certify, and publish an app" },
    ],
  },
  {
    id: "sarcasm",
    title: "Sarcasm NLP",
    description:
      "A neural network trained to recognize sarcasm in news article headlines. Built with TensorFlow and served via a Flask API on Amazon EC2.",
    link: "https://github.com/azolyomi/sarcasm-nlp",
    image: SarcasmDetection,
    techTags: ["Python", "TensorFlow", "Flask", "Node.js", "React"],
    gradient: {
      background: "linear-gradient(to bottom right, #0F2027, #203A43, #2C5364)",
      accent: "#0096FF",
      from: "#0F2027",
      to: "#2C5364",
    },
    learningTargets: [
      { target: "Python", desc: "primary scripting language" },
      { target: "TensorFlow", desc: "Google's Machine Learning library" },
      { target: "Flask", desc: "Python webserver hosted on Amazon EC2" },
      {
        target: "Node.js",
        desc: "front-end web scraping of popular news headlines",
      },
    ],
  },
];
